import { transformRefStationCRSValues } from 'templates/CRS/utils'

export function convertRawCompanyPosition (raw, state) {
  return transformRefStationCRSValues(state, raw)
}
